import { StyleRules } from '@material-ui/core/styles';
import { InputBaseClassKey } from '@material-ui/core/InputBase/InputBase';

export const MuiInputBase: Partial<StyleRules<InputBaseClassKey, Record<string, unknown>>> | undefined = {
  input: {
    borderRadius: 10,
    fontSize: 16,
    lineHeight: '24px',
    '@media (max-width:600px)': {
      borderRadius: 7,
    },
  },
};
